const MIN_PASSWORD_LENGTH = 6;
const MAX_PASSWORD_LENGTH = 12;

export function passwordIsStrongEnough(password:string):boolean {
	if (password.length < 6){
		return false;
	}
	if (!/\d/.test(password)){
		return false;
	}
	if (!/[a-z]/.test(password)){
		return false;
	}
	if (!/[A-Z]/.test(password)){
		return false;
	}
	return true;
}

export function generateRandomPassword():string{
	let password = Math.random().toString(36).substring(2);
	password += Math.random().toString(36).substring(2);
	let length = Math.round((MIN_PASSWORD_LENGTH + (Math.random() * (password.length - MIN_PASSWORD_LENGTH))));
	if (length > MAX_PASSWORD_LENGTH){
		length = MAX_PASSWORD_LENGTH;
	}
	let maxOffset = password.length - length;
	let offset = Math.round(Math.random() * maxOffset);
	password = password.slice(offset, offset + length);
	let exp = /[a-z]/g;
	let m:RegExpMatchArray|null = null;
	let letters:RegExpMatchArray[] = [];
	do {
		m = exp.exec(password);
		if (m){
			letters.push(m);
		}
	}while(m);

	let toReplaceLettersCount = Math.max(Math.floor(Math.random() * letters.length - 1), 1);
	let passwordParts = password.split("");
	for (let i = toReplaceLettersCount; i >= 0; i--){
		let letter = letters[Math.floor(Math.random() * letters.length)];
		if (letter.index === undefined) continue;
		passwordParts[letter.index] = passwordParts[letter.index].toUpperCase();
		letters.splice(i, 1);
	}
	password = passwordParts.join("");
	if (!passwordIsStrongEnough(password)){
		return generateRandomPassword();
	}
	return password;
}
